import React from "react"
import { graphql } from "gatsby"
// import PortableText from "@sanity/block-content-to-react"
// import urlBuilder from "@sanity/image-url"
// import Image from "../components/image"
import SEO from "../components/seo"
// import { node } from "prop-types"

import Layout from "../components/layout"
// import BackgroundImage from "gatsby-background-image"
import IndexTopContainer from "../components/indexPage/IndexTopContainer"
import IndexBottomContainer from "../components/indexPage/IndexBottomContainer"
// import IndexHeader from "../components/header/indexHeader"

// const urlFor = source =>
//   urlBuilder({
//     projectId: "ij3w87az",
//     dataset: "production",
//   }).image(source)

// console.log(process.env)

// const serializer = {
//   types: {
//     inlineImage: props => {
//       return (
//         <figure>
//           <img
//             alt={props.node.alt}
//             src={urlFor(props.node.asset)
//               .width(200)
//               .url()}
//           />
//           {/* <figcaption>{props.node.caption}</figcaption> */}
//         </figure>
//       )
//     },
//   },
// }

const IndexPage = ({ data }) => {
  // const rawRichText = data.homePageContent._rawSampleRichText
  const backgroundImage =
    data.indexBackground.edges[0].node.childImageSharp.fluid

  // for information on layering backgroudn iages with gatsby-background-image:
  // https://www.gatsbyjs.org/packages/gatsby-background-image/#how-to-use-with-multiple-images
  const backgroundFluidImageStack = [
    backgroundImage,
    `linear-gradient(0deg, rgba(18,47,111,1) 0%,rgba(18,47,111,1) 20%, rgba(255,255,255,0) 100%)`,
  ].reverse()

  const bottomBackgroundFluidImageStack = [
    backgroundImage,
    `linear-gradient(0deg, rgba(255,255,255,0) 0%,rgba(18,47,111,1) 70%, rgba(18,47,111,1) 100%)`,
  ].reverse()

  return (
    <Layout>
      <SEO title="Home" />
      <div className="indexPage__container">
        <IndexTopContainer fluid={backgroundFluidImageStack} />
        <IndexBottomContainer fluid={bottomBackgroundFluidImageStack} />
      </div>
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query {
    indexBackground: allFile(
      filter: { relativePath: { eq: "indexBackground.jpg" } }
    ) {
      edges {
        node {
          relativePath
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  }
`
